<template>
    <div class="outDiv" v-loading="isLoading">
        <div class="serviceopen">
            <div style="display:flex;align-items:center">
                <span class="approveTitle">人脸信息登记详情</span>
            </div>
        </div>
        <div class="openForm">
            <el-form labelWidth="160px" labelPosition="right" size="medium">
                <el-row :span="24">
                    <el-form-item label="老人姓名">
                        <span>{{ faceApproveDetail.theOldName }}</span>
                    </el-form-item>
                </el-row>
                <el-row :span="24">
                    <el-form-item label="身份证号码">
                        <span>{{ faceApproveDetail.idCard }}</span>
                    </el-form-item>
                </el-row>

                <el-row :span="24">
                    <el-form-item label="所属社区">
                        <span>{{ faceApproveDetail.community }}</span>
                    </el-form-item>
                </el-row>
                <!-- v-if="faceApproveDetail.isUpdateTheOld" -->

                <el-row :span="24">
                    <el-form-item label="老人人脸照片">
                        <img :src="faceApproveDetail.theOldPicture" style="width: 200px;" />
                    </el-form-item>
                    <el-form-item label="更新老人人脸照片" v-if="faceApproveDetail.isUpdateTheOld">
                        <img :src="faceApproveDetail.updatePicturePath" style="width: 200px;" />
                    </el-form-item>
                </el-row>
                <el-row :span="24" v-if="!faceApproveDetail.isUpdateTheOld">
                    <el-form-item label="联系人姓名">
                        <span>{{ faceApproveDetail.contactName }}</span>
                    </el-form-item>
                </el-row>
                <el-row :span="24" v-if="!faceApproveDetail.isUpdateTheOld">
                    <el-form-item label="与老人关系">
                        <span>{{ faceApproveDetail.relationship }}</span>
                    </el-form-item>
                </el-row>
                <el-row :span="24" v-if="!faceApproveDetail.isUpdateTheOld">
                    <el-form-item label="联系人电话">
                        <span>{{ faceApproveDetail.contactPhone }}</span>
                    </el-form-item>
                </el-row>
                <el-row :span="24" v-if="!faceApproveDetail.isUpdateTheOld">
                    <el-form-item label="联系人人脸照片">
                        <img :src="faceApproveDetail.contactPicture" style="width: 200px;" />
                    </el-form-item>
                    <el-form-item label="更新联系人人脸照片">
                        <img :src="faceApproveDetail.updatePicturePath" style="width: 200px;" />
                    </el-form-item>

                </el-row>

                <el-row :span="24">
                    <el-form-item label="是否通过">
                        <el-select v-model="status">
                            <el-option label="通过" value="1"></el-option>
                            <el-option label="不通过" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>

                <el-row :span="24">
                    <el-form-item>
                        <el-button type="primary" @click="handleUpdate">确定</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
    </div>
</template>
<script>
import {
    getFaceApproveDetail,
    faceInfoUpdate
} from "@/services/all-api.js"
import { mapState } from "vuex";
import dataApi from "./_api/api";
import { async } from "q";
export default {
    data() {
        return {
            status: "1",
            isLoading: false,
            faceApproveDetail: {}
        };
    },
    computed: {
        ...mapState(["oneObj"])
    },
    methods: {
        handleFaceApproveDetail() {
            getFaceApproveDetail({
                gid: sessionStorage.getItem("faceUpdateGid"),
            }).then(res => {
                console.log(res.data);
                this.faceApproveDetail = res.data;
            });
        },
        handleUpdate() {
            this.isLoading = true;

            //整合接口后
            let obj = {
                gid: this.faceApproveDetail.gid,
                IsUpdateTheOld: this.faceApproveDetail.isUpdateTheOld,
                status: this.status
            }

            faceInfoUpdate(obj).then(res => {
                this.isLoading = false;
                if (res.code === 0) {
                    this.$message.success("更新成功");
                    this.$router.go(-1);
                } else {
                    this.$message.error(`更新失败:${res.des || ""}`);
                }

            });

        }
    },
    created() {
        this.handleFaceApproveDetail();
        console.log(sessionStorage.getItem("faceUpdateGid"));
    },
    mounted() { }
};
</script>  
<style lang="scss" scoped>
.outDiv {
    width: 100%;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #ebeef5;
    padding: 20px;
    min-height: 200px;
}

.serviceopen {
    display: flex;
    flex-flow: row;
}

.openForm {
    padding-top: 30px;
}

.textFont {
    font-size: 14px;
    color: green;
}
</style>
